import React from 'react'

function TeamMemberCard({ name, title, photoUrl, education, certification }) {
  return (
    <div
      className="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-8 p-8 bg-background rounded-2xl shadow-lg mb-6 border border-[#D8C4B6] transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-xl"
      style={{ borderColor: '#D8C4B6', transition: 'transform 0.3s ease' }}
      onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.02)')}
      onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
    >
      {/* 左邊圖片 */}
      <div className="flex-shrink-0">
        <img
          src={photoUrl}
          alt={name}
          className="w-64 h-64 rounded-2xl object-cover object-top mx-auto md:mx-0"
        />
      </div>

      {/* 右邊文字內容 */}
      <div className="flex-1 text-left mx-auto md:mx-0">
        <h3 className="text-2xl font-ec font-bold text-textPrimary">
          {name} {title}
        </h3>

        {/* 學經歷 / 專業認證 區域 */}
        <div className="mt-4 flex flex-col md:flex-row md:space-x-8">
          {/* 學經歷 */}
          <div className="flex-1 md:pr-4">
            <h4 className="text-xl font-ec text-textSecondary mb-2">
              <i className="fa-solid fa-user-graduate"></i> 學經歷
            </h4>
            <div className="font-ec text-textSecondary space-y-1">
              {education.map((edu, idx) => (
                <div key={idx}>◼️ {edu}</div>
              ))}
            </div>
          </div>

          {/* 專業認證 */}
          {certification.length > 0 && (
            <div className="flex-1 md:pl-4 md:border-l md:border-gray-300">
              <h4 className="text-xl font-ec text-textSecondary mb-2">
                <i className="fa-solid fa-award"></i> 專業認證
              </h4>
              <div className="font-ec text-textSecondary space-y-1">
                {certification.map((cert, idx) => (
                  <div key={idx}>◼️ {cert}</div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TeamMemberCard
